export const rowsPerPageOptions = [25, 50, 100, 250, 500];
export const defaultRowsPerPageOption = 50;
